/**
 * Zero line is an imagenary horizontal line on screen where parallax
 * component should centered.
 * For initlially visible element zelo line is its inital position.
 * For elements out of viewport zero line is in the midle of viewport.
 */
const getZeroLine = (el) => {
    const { dataset } = el;
    let zeroLine = parseFloat(dataset.zeroLine);

    if (Number.isNaN(zeroLine)) {
        const rect = el.getBoundingClientRect();
        const midY = rect.top + rect.height / 2;

        zeroLine =
            midY >= 0 && midY <= window.innerHeight
                ? midY
                : window.innerHeight / 2;

        dataset.zeroLine = zeroLine;
    }

    return zeroLine;
};

if (!customElements.get("parallax-component")) {
    class ParallaxComponent extends HTMLElement {
        constructor() {
            super();

            this.raf = null;

            this.onScroll = () => {
                // throttles updates to once per animation frame
                if (this.raf) return;

                this.raf = requestAnimationFrame(() => {
                    this.raf = null;
                    this.update();
                });
            };
        }

        connectedCallback() {
            this.update();
            document.addEventListener("scroll", this.onScroll, {
                passive: true,
            });

            // clear zeroLine on resize
            window.addEventListener("resize", () => {
                document
                    .querySelectorAll("parallax-component [data-zero-line]")
                    .forEach((el) => {
                        delete el.dataset.zeroLine;
                    });
            });
        }

        disconnectedCallback() {
            document.removeEventListener("scroll", this.onScroll);

            if (this.raf) {
                cancelAnimationFrame(this.raf);
                this.raf = null;
            }
        }

        getSpeed() {
            const speed = parseFloat(this.dataset.speed);
            return Number.isNaN(speed) ? 0.2 : speed;
        }

        getOffsetY(el) {
            const rect = el.getBoundingClientRect();
            const elementCenter = rect.top + rect.height / 2;
            return elementCenter - getZeroLine(el);
        }

        update() {
            const speed = this.getSpeed();

            // update bg image position
            if (this.dataset.backgroundParallax == "true") {
                this.updateBackgroundImagePosition();
                return;
            }

            for (const child of this.children) {
                switch (child.tagName) {
                    case "IMG":
                        this.updateImg(child, speed);
                        break;

                    case "SVG":
                        this.updateSvg(child, speed);
                        break;

                    default:
                        this.applyTransform(child, speed);
                }
            }
        }

        updateBackgroundImagePosition(speed) {
            const bgHeight = 490; // background-size height
            const s = speed || 0.15;
            let y = -this.getOffsetY(this) * s;

            y %= bgHeight;
            this.style.setProperty("--parallax-y", `${y}px`);
        }

        applyTransform(el, speed) {
            const y = -this.getOffsetY(el) * speed;

            el.style.transform = `translateY(${y}px)`;
            el.style.transition = "none";
        }

        updateImg(img, speed) {
            const y = this.getOffsetY(img) * speed;
            const { dataset, style } = img;

            const original =
                dataset.originalObjectPosition ||
                style.objectPosition ||
                "50% 50%";

            if (!dataset.originalObjectPosition) {
                dataset.originalObjectPosition = original;
            }

            const [xPos, base] = original.split(" ");
            const origin = this.dataset.originalObjectPosition;

            style.objectPosition = `${xPos} calc(${base} ${
                origin === "bottom" ? "-" : "+"
            } ${y}px)`;

            style.transition = "none";
        }

        updateSvg(svg, speed) {
            const y = (-this.getOffsetY(svg) * speed) / 2;

            for (const child of svg.children) {
                child.style.transform = `translateY(${y}px)`;
            }
        }
    }

    customElements.define("parallax-component", ParallaxComponent);
}
